import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'
import { ThemeProvider } from '@vibe/core'
import { CustomThemeProvider } from './theme'
import { AuthProvider } from './contexts/AuthContext'
import { AuthGuard } from './components/common/AuthGuard'
import {
  UserManagementRoute,
  RoleManagementRoute,
  JobDefinitionManagementRoute,
} from './components/common/RouteGuard'
import {
  Login,
  Dashboard,
  NewRequirement,
  CandidatesManagement,
  CandidateDetail,
  UserManagement,
  RoleManagement,
  WorkflowManagement,
  JobDefinitionManagement,
  NewJobDefinition,
  IntegrationsManagement,
} from './pages'
import './App.css'

function App() {
  return (
    <CustomThemeProvider
      initialBranding={{
        organizationName: 'Talent Match',
        primaryColor: '#0867ec',
        supportEmail: 'support@talentmatch.com',
      }}
    >
      <ThemeProvider>
        <AuthProvider>
          <Router>
            <Routes>
              {/* Public routes */}
              <Route
                path="/login"
                element={
                  <AuthGuard requireAuth={false}>
                    <Login />
                  </AuthGuard>
                }
              />

              {/* Protected routes */}
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/new-requirement" element={<NewRequirement />} />
              <Route
                path="/candidates/:solicitudId"
                element={<CandidatesManagement />}
              />
              <Route path="/candidate/:id" element={<CandidateDetail />} />
              <Route
                path="/users"
                element={
                  <UserManagementRoute>
                    <UserManagement />
                  </UserManagementRoute>
                }
              />
              <Route
                path="/roles"
                element={
                  <RoleManagementRoute>
                    <RoleManagement />
                  </RoleManagementRoute>
                }
              />
              <Route
                path="/workflows"
                element={
                  <UserManagementRoute>
                    <WorkflowManagement />
                  </UserManagementRoute>
                }
              />
              <Route
                path="/job-definitions"
                element={
                  <JobDefinitionManagementRoute>
                    <JobDefinitionManagement />
                  </JobDefinitionManagementRoute>
                }
              />
              <Route
                path="/job-definitions/new"
                element={
                  <JobDefinitionManagementRoute>
                    <NewJobDefinition />
                  </JobDefinitionManagementRoute>
                }
              />
              <Route
                path="/integrations"
                element={
                  <UserManagementRoute>
                    <IntegrationsManagement />
                  </UserManagementRoute>
                }
              />

              {/* Default redirect */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />

              {/* Catch-all route for 404 */}
              <Route
                path="*"
                element={
                  <AuthGuard>
                    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                      <div className="text-center">
                        <h1 className="text-4xl font-bold text-gray-900 mb-4">
                          404
                        </h1>
                        <p className="text-gray-600 mb-4">
                          Página no encontrada
                        </p>
                        <Navigate to="/dashboard" replace />
                      </div>
                    </div>
                  </AuthGuard>
                }
              />
            </Routes>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </CustomThemeProvider>
  )
}

export default App
